<template>
  <VIcon 
    class="w-icon"
    v-bind="$props"
    v-on="$listeners"
  >
    <slot />
  </VIcon>
</template>

<script>
import { VIcon } from 'vuetify/lib';

export default {
  name: 'WorkIcon',
  components: { VIcon },
  props: {
    ...VIcon.options.props,
    disabled: { type: Boolean, default: false },
    color: { type: String, default: 'primary' },
    size: { type: [Number, String], default: '1.25rem' }
  },
};
</script>
